import React from 'react';

import classNames from 'classnames';

import UserPicture from '@/components/Common/UserPicture';

import FieldValue from './FieldValue';

const FieldRow = ({ item, itemKey, formatMessage, styles, tooltip, onCopy }) => {
  if (item.hideLabel && item.type === 'user-photo') {
    if (!item.value) return null;
    const { size, shape } = item.viewProps || {};
    return (
      <div className={styles.userPhotoOnly}>
        <UserPicture
          id={item.value}
          size={size || 98}
          shape={shape || 'circle'}
          showTooltip={false}
        />
      </div>
    );
  }

  const isSwitch = item.type === 'switch';
  const hideLabel = item.hideLabel;
  const rowClass = classNames(
    styles.fieldRow,
    isSwitch && styles.fieldRowSwitch,
    hideLabel && styles.fieldRowMedia,
  );
  const labelClass = styles.fieldLabel;
  const valueClass = styles.fieldValue;

  const value = (
    <FieldValue
      item={item}
      itemKey={itemKey}
      formatMessage={formatMessage}
      styles={styles}
      tooltip={tooltip}
      onCopy={onCopy}
    />
  );

  if (hideLabel) {
    return (
      <div className={rowClass}>
        <dd className={valueClass}>{value}</dd>
      </div>
    );
  }

  return (
    <div className={rowClass}>
      <dt className={labelClass}>{formatMessage({ id: item.label })}</dt>
      <dd className={valueClass}>{value}</dd>
    </div>
  );
};

export default FieldRow;
